import { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('app_lang') || 'fr');

  const toggleLang = useCallback(() => {
    setLang(prev => {
      const next = prev === 'fr' ? 'de' : 'fr';
      localStorage.setItem('app_lang', next);
      return next;
    });
  }, []);

  const setLanguage = useCallback((l) => {
    localStorage.setItem('app_lang', l);
    setLang(l);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
